const nav = document.getElementById('navigation');
const burger = nav?.querySelector('.c-nav__burger');
const drawer = document.getElementById('navigation-drawer');
const closeBtn = drawer?.querySelector('.c-nav__drawer-close');

const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

const isOpen = () => burger?.getAttribute('aria-expanded') === 'true';

// tylko widoczne kontrolki — zamknięty drawer ma `visibility: hidden`,
// a offsetParent === null również dla pozycji ukrytych przez breakpoint
const focusables = () => Array.from(drawer?.querySelectorAll(FOCUSABLE) ?? [])
	.filter((el) => el.offsetParent !== null);

// Jedno źródło prawdy o stanie: aria-expanded na burgerze + klasa .is-open
// na panelu. Blokada scrolla body i fokus są tylko pochodnymi tego stanu.
const setOpen = (open) => {
	if (!burger || !drawer) {
		return;
	}

	if (open === isOpen()) {
		return;
	}

	burger.setAttribute('aria-expanded', String(open));
	drawer.classList.toggle('is-open', open);
	document.body.classList.toggle('has-nav-open', open);

	if (open) {
		// fokus do wnętrza panelu — pierwsza kontrolka to „zamknij"
		(closeBtn ?? focusables()[0])?.focus();
	} else {
		// i z powrotem na burgera, żeby nie wylądował na <body>
		burger.focus();
	}
};

burger?.addEventListener('click', () => setOpen(!isOpen()));

closeBtn?.addEventListener('click', () => setOpen(false));

// kliknięcie pozycji zamyka drawer — inaczej po przejściu do anchora zasłania treść
drawer?.querySelectorAll('.c-nav__drawer-link:not(.is-disabled)').forEach((link) => {
	link.addEventListener('click', () => setOpen(false));
});

// kliknięcie poza panelem zamyka; burger wyłączony z testu, bo jego własny
// handler już przełącza stan i inaczej otwarcie zamykałoby się natychmiast
document.addEventListener('click', (event) => {
	if (!isOpen()) {
		return;
	}

	if (drawer?.contains(event.target) || burger?.contains(event.target)) {
		return;
	}

	setOpen(false);
});

// ---------------------------------------------------------------------------
// Podświetlanie pozycji menu sekcją, na której stoi scroll (Figma 160:2963).
// ---------------------------------------------------------------------------

const ACTIVE = 'is-active';

// Wszystkie linki menu — belka i drawer razem, bo pokazują tę samą nawigację
// i muszą być zgodne po zmianie breakpointu bez ponownej inicjalizacji.
const menuLinks = Array.from(nav?.querySelectorAll('.c-nav__link[href], .c-nav__drawer-link[href]') ?? []);

// Linki wskazujące inną stronę (np. laureaci) nie biorą udziału w scrollspy —
// dla nich stan aktywny wynika ze ścieżki i jest ustawiany raz.
const anchorLinks = menuLinks.filter((link) => {
	const samePage = link.pathname === window.location.pathname && link.hash;

	if (!samePage) {
		link.classList.toggle(ACTIVE, link.pathname === window.location.pathname);
	}

	return samePage;
});

// Pary [sekcja, linki]. Kilka linków na tę samą sekcję to norma (belka +
// drawer). Sekcje jeszcze niezbudowane (#zgloszenia, #zasady, #nagrody) po
// prostu nie trafiają na listę — spy zacznie je obsługiwać, gdy powstaną.
const spied = [];

anchorLinks.forEach((link) => {
	const section = document.getElementById(decodeURIComponent(link.hash.slice(1)));

	if (!section) {
		return;
	}

	const entry = spied.find((item) => item.section === section);

	if (entry) {
		entry.links.push(link);
	} else {
		spied.push({ section, links: [link] });
	}
});

// IntersectionObserver świadomie odrzucony: przy sekcjach wyższych i niższych
// od okna „która jest widoczna" nie ma jednej odpowiedzi. Bierzemy ostatnią
// sekcję, której górna krawędź minęła linię pod belką nawigacji — to ta, którą
// użytkownik faktycznie czyta, i to samo miejsce, na które celuje
// `scroll-padding-top: $nav-h` z generic.scss.
const syncActive = () => {
	if (!spied.length) {
		return;
	}

	const line = nav?.offsetHeight ?? 0;
	let current = null;

	spied.forEach((item) => {
		if (item.section.getBoundingClientRect().top - 1 <= line) {
			current = item;
		}
	});

	// dno strony: ostatnia sekcja wygrywa nawet gdy jej górna krawędź jest
	// jeszcze pod linią (krótka sekcja stopki nie da się „doscrollować")
	const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;

	if (atBottom) {
		current = spied[spied.length - 1];
	}

	spied.forEach((item) => {
		item.links.forEach((link) => link.classList.toggle(ACTIVE, item === current));
	});
};

// jedno przeliczenie na klatkę — scroll leci znacznie częściej
let scheduled = false;

const requestSync = () => {
	if (scheduled) {
		return;
	}

	scheduled = true;
	requestAnimationFrame(() => {
		scheduled = false;
		syncActive();
	});
};

if (spied.length) {
	document.addEventListener('scroll', requestSync, { passive: true });
	window.addEventListener('resize', requestSync);
	// hero dolicza swoją wysokość w JS po detekcji silnika (assets/js/hero.js),
	// więc pozycje sekcji zmieniają się jeszcze po DOMContentLoaded
	window.addEventListener('load', requestSync);
	syncActive();
}

document.addEventListener('keydown', (event) => {
	if (!isOpen()) {
		return;
	}

	if (event.key === 'Escape') {
		setOpen(false);

		return;
	}

	// pułapka fokusu: Tab i Shift+Tab krążą wewnątrz otwartego panelu
	if (event.key !== 'Tab') {
		return;
	}

	const items = focusables();

	if (!items.length) {
		return;
	}

	const first = items[0];
	const last = items[items.length - 1];
	const active = document.activeElement;

	if (event.shiftKey && (active === first || !drawer.contains(active))) {
		event.preventDefault();
		last.focus();
	} else if (!event.shiftKey && (active === last || !drawer.contains(active))) {
		event.preventDefault();
		first.focus();
	}
});
